<template>
  <div>
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <b-form-group
        id="Lident"
        label="Identifica"
        label-for="ident"
        description="ID del tramo"
      >
        <b-form-input
          id="ident"
          v-model="form.identifica"
          :required="true"
          :disabled="true"
        />
      </b-form-group>
      <b-form-group
        id="Lsc"
        label="Suncuenca"
        label-for="sc"
        description="Subcuenca"
      >
        <b-form-input
          id="sc"
          v-model="form.lavado_subcuenca"
          :required="true"
          :disabled="true"
        />
      </b-form-group>
      <b-form-group
        id="Lfecha"
        label="Fecha"
        label-for="fecha"
        description="Fecha de lavado"
      >
        <date-picker
          v-model="form.lavado_fecha"
          id="fecha"
          valueType="format"
          lang="es"
          :placeholder="(form.lavado_fecha!=null)?new Date(form.lavado_fecha).toLocaleDateString():null"
          :required="true"
          :first-day-of-week="1"

        ></date-picker>
      </b-form-group>
      <b-form-group
        id="label0"
        label="Tipo de Limpieza"
        label-for="input0"
        description="tipo de limpieza que se a ejecutado "
      >
        <b-form-select
          v-model="form.lavado_tipo"
          :options="optionTipo"
          required
        />
      </b-form-group>
      <b-form-group
        id="Lmetros"
        label="Longitud"
        label-for="metros"
        description="Longitud de terreno"
      >
        <b-form-input
          id="metros"
          type="number"
          v-model="form.lavado_longitud"
          :required="true"
        />
      </b-form-group>
      <b-form-group
        id="Lshapel"
        label="Largo"
        label-for="shapel"
        description="largo del shape"
      >
        <b-form-input
          id="shapel"
          v-model="form.lavado_longshape"
          :required="true"
          :disabled="true"
        />
      </b-form-group>
      <b-form-group
        v-show="form.lavado_tipo === 'No lavada'"
        id="label8"
        label="Causa no lavado"
        label-for="input8"
        description="La causa por la cual no se lavo el tramo"
      >
        <b-form-select
          id="input8"
          v-model="form.causalvd"
          :options="optionsCausas"
          :required="form.lavado_tipo === 'No lavada'"
        />
      </b-form-group>
      <b-form-group
        id="Lobs"
        label="Observacion"
        label-for="obs"
        description="Adjuntar informacion sobre lavado"
      >
        <b-form-textarea
          id="obs"
          type="text"
          v-model="form.lavado_obs"
          rows="3"
          max-rows="6"
          :required="form.lavado_tipo === 'No lavada'"
        />
      </b-form-group>
      <b-form-group
        id="label4"
        label="Operadores"
        label-for="input4"
        description="Operador del camion"
      >
        <b-form-select
          id="input4"
          v-model="form.operadorlvd"
          :options="optionsOperadores"
          @change="patenteToOperador"
          :required="form.lavado_tipo  !== 'No lavada'"
        />
      </b-form-group>
      <b-form-group
        id="label3"
        label="Patente"
        label-for="input3"
        description="Patente del camion"
      >
        <b-form-select
          id="input3"
          v-model="form.patente"
          :options="optionsPatentes"
          :required="form.lavado_tipo  !== 'No lavada'"
        />
      </b-form-group>
      <b-form-group
        id="Lorden"
        label="ODS"
        label-for="orden"
        description=" N° Orden"
      >
        <b-form-input
          id="orden"
          v-model="form.lavado_orden"
        />
      </b-form-group>
      <b-form-group
        id="Linicio"
        label="Inicio"
        label-for="inicio"
        description=" Hora de inicio"
      >
        <date-picker
          id="inicio"
          v-model="form.lavado_inicio"
          lang="es"
          type="time"
          :placeholder="(form.lavado_inicio!=null)?new Date(form.lavado_inicio).toLocaleTimeString():null"
          @change="calculahora"
          format="HH:mm:ss"
        ></date-picker>
      </b-form-group>
      <b-form-group
        id="Lfin"
        label="Fin"
        label-for="fin"
        description=" Hora de finalizado"
      >
        <date-picker
          id="fin"
          v-model="form.lavado_fin"
          lang="es"
          type="time"
          :placeholder="(form.lavado_fin!=null)?new Date(form.lavado_fin).toLocaleTimeString():null"
          format="HH:mm:ss"
          @change="calculahora">

        </date-picker>
      </b-form-group>
      <b-form-group
        id="Ltiempo"
        label="Tiempo"
        label-for="tiempo"
        description="Tiempo de ejecucion"
      >
        <b-form-input
          id="tiempo"
          v-model="form.lavado_tiempo"
          :disabled="true"
        />
      </b-form-group>
      <b-button type="submit" variant="primary">Enviar</b-button>
    </b-form>
  </div>
</template>

<script>
    /* eslint-disable no-console */

    import DatePicker from "vue2-datepicker";
    import Http from "../Http";
    import EventBus from "../Bus";
    import store from "../store/";

    export default {
        name: "Lavado",
        components: {DatePicker},
        props: ['subcu', 'identifica', 'shal', 'predata', 'datos'],
        computed: {
            optionsCausas() {
                return this.causas
                    .filter(x => x.causa_id !== 19)
                    .map(x => ({
                        value: x.causa_id,
                        text: x.causa_nombre
                    }));
            },
            optionsPatentes() {
                return this.patentes
                    .filter(x => x.patente_id !== 12)
                    .map(x => ({
                        value: x.patente_id,
                        text: x.patente_nombre
                    }));
            },
            optionsOperadores() {
                return this.operadoresLtv
                    .filter(x => x.operador_id !== 12)
                    .map(x => ({
                        value: x.operador_id,
                        text: x.operador_nombre
                    }));
            }
        },
        data: () => ({
            optionTipo: [
                {value: null, text: "Seleccione una opcion"},
                {value: "Hidráulica", text: "Hidráulica"},
                {value: "No lavada", text: "No lavada"}
            ],
            causas: [],
            form: {
                identifica: null,
                lavado_subcuenca: null,
                lavado_fecha: null,
                lavado_tipo: null,
                lavado_longitud: null,
                lavado_longshape: null,
                causalvd: null,
                lavado_obs: null,
                operadorlvd: null,
                patente: null,
                lavado_inicio: null,
                lavado_fin: null,
                lavado_tiempo: null,
                lavado_orden: null,
            },
            lang: {
                days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                months: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                pickers: [
                    "next 7 days",
                    "next 30 days",
                    "previous 7 days",
                    "previous 30 days"
                ],
                placeholder: {
                    date: "Seleccione Fecha",
                    dateRange: "Seleccone Rango"
                }
            },
            patentes: [],
            operadoresLtv: []
        }),
        mounted() {
            this.getCausas();
            this.form.identifica = this.identifica;
            this.form.lavado_subcuenca = this.subcu;
            this.form.lavado_longshape = this.shal;
            if (this.datos != null) {
                this.cargarDatoslvd();
            }
            Http.Http()
                .get(`Preinf/Patentes`)
                .then(resp => {
                    this.patentes = resp.data;
                    console.log(resp.data);
                })
                .catch(err => {
                    console.log(err);
                });
            Http.Http()
                .get("Preinf/Operadoreslvd")
                .then(resp => {
                    this.operadoresLtv = resp.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        methods: {
            getCausas() {
                Http.Http()
                    .get("Preinf/Causalvd")
                    .then(resp => {
                        this.causas = resp.data;
                    })
                    .catch(err => {
                        // eslint-disable-next-line no-console
                        console.log(err);
                    });
            },
            patenteToOperador() {
                let patente = this.operadoresLtv.find(
                    x => x.operador_id === this.form.operadorlvd
                );
                this.form.patente = patente.patente_id;
            },
            cargarDatoslvd() {
                let tmp = this.datos;
                this.form.lavado_fecha = tmp.lavado_fecha;
                this.form.lavado_tipo = tmp.lavado_tipo;
                this.form.lavado_longitud = tmp.lavado_longitud;
                this.form.causalvd = tmp.causalvd;
                this.form.lavado_obs = tmp.lavado_obs;
                this.form.operadorlvd = tmp.operadorlvd;
                this.form.patente = tmp.patente;
                let init = tmp.lavado_inicio.split(":");
                this.form.lavado_inicio = new Date().setHours(init[0], init[1], init[2]);
                let fin = tmp.lavado_fin.split(":");
                this.form.lavado_fin = new Date().setHours(fin[0], fin[1], fin[2]);
                this.form.lavado_tiempo = tmp.lavado_tiempo;
                this.form.lavado_orden = tmp.lavado_orden;
            },
            calculahora() {
                let tiempo = (this.form.lavado_fin - this.form.lavado_inicio);
                this.form.lavado_tiempo = (tiempo >= 0) ? (((tiempo / 1000) / 60) / 60) + " Hrs" : '';
            },
            onSubmit() {
                let form = {
                    identifica: this.form.identifica,
                    lavado_subcuenca: this.form.lavado_subcuenca,
                    lavado_fecha: this.form.lavado_fecha,
                    lavado_tipo: this.form.lavado_tipo,
                    lavado_longshape: this.form.lavado_longshape,
                    user_id: store.state.User.CurrentUser.user_id
                };
                if (this.form.lavado_tipo === "No lavada") {
                    Object.defineProperty(form, "causalvd", {
                        value: this.form.causalvd,
                        writable: true,
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(form, "lavado_obs", {
                        value: this.form.lavado_obs,
                        writable: true,
                        enumerable: true,
                        configurable: true
                    });
                }
                if (this.form.lavado_tipo === "Hidráulica") {
                    Object.defineProperties(form, {
                        "lavado_longitud": {
                            value: this.form.lavado_longitud,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        },

                        "operadorlvd": {
                            value: this.form.operadorlvd,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        },
                        "patente": {
                            value: this.form.patente,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        },
                        "lavado_inicio": {
                            value: new Date(this.form.lavado_inicio).toLocaleTimeString(),
                            writable: true,
                            enumerable: true,
                            configurable: true
                        },
                        "lavado_fin": {
                            value: new Date(this.form.lavado_fin).toLocaleTimeString(),
                            writable: true,
                            enumerable: true,
                            configurable: true
                        },
                        "lavado_tiempo": {
                            value: this.form.lavado_tiempo,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        }
                    });
                    if (this.form.lavado_obs != null) {
                        Object.defineProperty(form, "lavado_obs", {
                            value: this.form.lavado_obs,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        });
                    }
                }
                if (this.form.lavado_orden != null) {
                    Object.defineProperty(form, "lavado_orden", {
                        value: this.form.lavado_orden,
                        writable: true,
                        enumerable: true,
                        configurable: true
                    });
                }
                console.log(form);
                if (this.datos == null) {
                    Http.Http().post("Informef/Lavado", {
                        data: JSON.stringify(this.predata),
                        accion: JSON.stringify(form)
                    })
                        .then(resp => {
                            if (resp.data === 10) {
                                alert("Datos previos existentes ");
                            } else {
                                alert("Los datos se insertado con exito");
                                EventBus.$emit("onPostdata", {id: this.form.identifica, state: resp.data});
                            }
                        })
                        .catch(err => console.log(err));
                } else this.update(form)
            },
            update(form) {
                Object.defineProperty(form, "id_lavado", {
                    value: this.datos.id_lavado,
                    writable: true,
                    enumerable: true,
                    configurable: true
                });
                Http.Http().put("Informef/Lavado", {data: JSON.stringify(this.predata), accion: JSON.stringify(form)})
                    .then(resp => {
                        console.log(resp);
                        alert("Los datos se actualizaron con exito");
                        EventBus.$emit("onPostdata", null);
                    })
                    .catch(err => console.log(err));
            }
        }
    };
</script>

<style scoped></style>
